if (!customElements.get('loyalty-points-pdp')) {
    customElements.define('loyalty-points-pdp', class LoyaltyPointsPdp extends HTMLElement {
      constructor() {
        super();
      }
  
      // disconnectedCallback() {
      //   document.removeEventListener("theme:cart:change", () => {
      //     this.updateLoyaltyPoints();
      //   });
      // }
  
      connectedCallback() {
        console.log('Loyalty points PDP connected');
       // this.updateLoyaltyPoints();

       this.fetchCustomerPoints(this.getAttribute('data-sku'), 1, parseFloat(this.getAttribute('data-price')));

       document.addEventListener("theme:variant:change", (event) => {
        //this.updateLoyaltyPoints();
        console.log('Variant changed', event.detail.variant);
        this.fetchCustomerPoints(event.detail.variant.sku, 1, event.detail.variant.price);
      });

      }

      async fetchCustomerPoints(sku, quantity, price) {
        if (!sku) {
          console.warn("Missing SKU for loyalty points request.");
          return;
        }
    
        try {
          // Prepare the payload for the API request
          const payload = {
            cartItems: [
              {
                sku: sku,
                quantity: quantity || 1,
                price: price ? price / 100 : 0,
              },
            ],
            state: "open",
          };
    
          // Loyalty Points API URL
          let url = `https://azsu-rg-integration-qa-func-talon.azurewebsites.net/api/loyalty/points/product?code=P2lX5NUxGMJK-pI4oX2MhDF9kVYZkv1dB4TxRSvwXqfJAzFuNKvuVQ==`;
          if(Shopify.shop === 'the-body-shop-uk.myshopify.com') {
            url = `https://azsu-integration-prod-apim-ecomm.azure-api.net/azsu-integration-prod-func-talonOne/loyalty/points/product`;
          }
          // Perform the API request
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
            redirect: "manual",
          });
    
          // Check if the response is successful
          if (response.status !== 200) throw new Error("API responded with an error.");
    
          // Parse the response JSON
          const responseJSON = await response.json();
          const points = responseJSON.points || 0; // Default to 0 points if none is returned
                
            // Update the points display for all users
            const loyaltyText = this.querySelector('[data-text]');
            if(!!loyaltyText){
              const text = loyaltyText.dataset.text.replace("__points__", points);
              loyaltyText.innerText = text;
            }
          const valueContainer = document.querySelectorAll(".loyalty-points__value-product");
          valueContainer.forEach((container) => {
            container.innerText = `${points}`;
          });
        } catch (error) {
          console.error("Error fetching loyalty points:", error);
        }
      }
    });
}
